import { Form as BaseForm, FormProps as BaseFormProps } from "@commonlibs";
import { ThemeSpacingValues } from "ui/config/theme/spacing/spacing.types.d";
import { FormWrapper } from "./Form.styles";
import { ReactNode } from "react";

export interface FormProps extends Omit<BaseFormProps, "children"> {
    /**
     * Form children
     */
    children: ReactNode;
    /**
     * gap
     */
    gap?: keyof ThemeSpacingValues;
}

const Form = ({ children, gap, ...rest }: FormProps) => {
    return (
        <BaseForm {...rest}>
            <FormWrapper className="form-wrapper" gap={gap}>
                {children}
            </FormWrapper>
        </BaseForm>
    );
};

export default Form;
